
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { LoginData, LoginStatus } from '@/store/types';
    import { VForm } from '@/types/Components';
    //import authService from '@/services/Authentication';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('authentication', ['status']),
        },
        methods: {
            ...mapActions('authentication', ['login']),
        },
    })
    export default class Login extends Vue {
        public status!: LoginStatus;
        public login!: (payload: LoginData) => Promise<void>;

        public $refs!: {
            form: VForm;
        };

        public readonly showPasswortanforderungRegistrierung = false;

        public data: LoginData = {
            username: '',
            password: '',
        };

        public get randomBackground(): string {
            return `background-${Math.floor(Math.random() * Math.floor(2))}`;
        }

        public onClickLogin(): void {
            if (!this.status.loggingIn && this.$refs.form.validate()) {
                this.login(this.data);
            }
        }

        public mounted(): void {
            /*authService.loginurl().then((response) => {
                if (response && response.data && response.data.body) {
                    document.location.href = response.data.body;
                }
            });*/
        }
    }
